import React from 'react';
import { createFileRoute } from '@tanstack/react-router';

import LogIn from '@pages/login/ui/LogIn';

export const Route = createFileRoute('/_guest/signin')({
  component: LogIn,
});
